import { UiTextField } from "@smp/ui";
import { useField } from "formik";
import { useMemo } from "react";

import { IFormTextFieldProps } from "./form_text_field.types";

export const FormTextField = ({ name, ...props }: IFormTextFieldProps) => {
  const [field, meta] = useField(name);

  return useMemo(
    () => (
      <UiTextField
        error={!!meta.touched && !!meta.error}
        errorMessage={
          !!meta.touched ? (meta.error ? meta.error : undefined) : undefined
        }
        {...field}
        {...props}
      />
    ),
    [field, meta.error, meta.touched, props],
  );
};
